import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { PostEditor } from "@/components/PostEditor";
import { useAuth } from "@/hooks/use-auth";

export const Route = createFileRoute("/admin/posts/new")({
  head: () => ({
    meta: [
      { title: "New post | Scott Cunningham" },
      { name: "description", content: "New post for Scott Cunningham’s website administration." },
      { property: "og:title", content: "New post | Scott Cunningham" },
      { property: "og:description", content: "New post for Scott Cunningham’s website administration." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
      { name: "twitter:title", content: "New post | Scott Cunningham" },
      { name: "twitter:description", content: "New post for Scott Cunningham’s website administration." },
      { name: "robots", content: "noindex" },
    ],
  }),
  component: NewPage,
});

function NewPage() {
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  useEffect(() => {
    if (loading) return;
    if (!user) navigate({ to: "/login" });
  }, [user, loading, navigate]);
  if (loading || !user) return <div className="p-12 text-muted-foreground">Loading…</div>;
  return <PostEditor postId={null} onDone={() => navigate({ to: "/admin" })} />;
}
